import { render, staticRenderFns } from "./PFContentFreelance.vue?vue&type=template&id=0047b356&scoped=true&"
import script from "./PFContentFreelance.vue?vue&type=script&lang=js&"
export * from "./PFContentFreelance.vue?vue&type=script&lang=js&"
import style0 from "./PFContentFreelance.vue?vue&type=style&index=0&id=0047b356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047b356",
  null
  
)

export default component.exports